module.exports = __webpack_public_path__ + "img/gb13871-92_60x80x8.prt.fb75ddb6.jpg";